module.exports = __webpack_public_path__ + "img/mt.mta39094a.svg";